import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { LoginForm } from '@src/components/LoginForm';
import { SignUpForm } from '@src/components/SignUpForm';
import { useAuth } from '@src/hooks/useAuth';
import { partition } from 'lodash';
import { CURRENT_AUTH_CONFIGS, Provider } from 'pe-core-frontend';
import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
export const Login = ({ signUp }) => {
    const { currentUser } = useAuth();
    const { data, loading } = useQuery(CURRENT_AUTH_CONFIGS);
    const authConfigs = useMemo(() => data?.currentAuthConfigs || [], [data]);
    const [[directLogin], others] = partition(authConfigs, config => config.provider === Provider.DIRECT);
    if (currentUser) {
        return _jsx(Navigate, { to: '/' });
    }
    if (!loading && !directLogin && signUp) {
        return _jsx(Navigate, { to: '/login' });
    }
    if (signUp) {
        return _jsx(SignUpForm, { directLoginConfig: directLogin });
    }
    return _jsx(LoginForm, { directLoginConfig: directLogin, otherConfigs: others });
};
